// import React from "react";
// import { Box, Typography, TextField, Button, Container, Paper, Stack } from "@mui/material";

// const TotalsSection = ({ investments, loans, returneds, total, activeTab, setActiveTab }) => {
//   const totalInvestment = Number(investments) || 0;
//   const totalLoan = Number(loans) || 0;
//   const totalReturned = Number(returneds) || 0;

//   // Always compute totalClaim strictly with formula, no conditionals altering it
//   const totalClaim = totalInvestment - totalLoan - totalReturned;

//   const goToNextTab = () => {
//     setActiveTab(activeTab + 1);
//   };

//   const goToPrevTab = () => {
//     if (activeTab > 0) setActiveTab(activeTab - 1);
//   };

//   return (
//     <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//       <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//         <Box sx={{ p: 2 }}>
//           <Typography variant="h6" gutterBottom>
//             Summary
//           </Typography>
//           <Stack spacing={2}>
//             <TextField
//               label="Total Invested Amount"
//               value={totalInvestment.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//             />
//             <TextField
//               label="Total Loan Amount"
//               value={totalLoan.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//             />
//             <TextField
//               label="Total Returned Amount"
//               value={totalReturned.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//             />
//             <TextField
//               label="Total Claim Amount"
//               value={totalClaim.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//             />
//           </Stack>
//           <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
//             <Button variant="outlined" onClick={goToPrevTab}>
//               Back
//             </Button>
//             <Button variant="contained" color="primary" onClick={goToNextTab}>
//               Next
//             </Button>
//           </Box>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default TotalsSection;


// import React from "react";
// import { Box, Typography, TextField, Button, Container, Paper, Stack } from "@mui/material";
// import { useTranslation } from "react-i18next";

// const TotalsSection = ({ investments, loans, returneds, total, activeTab, setActiveTab }) => {
//   const { t } = useTranslation();

//   const totalInvestment = Number(investments) || 0;
//   const totalLoan = Number(loans) || 0;
//   const totalReturned = Number(returneds) || 0;

//   // Always compute totalClaim strictly with formula, no conditionals altering it
//   const totalClaim = totalInvestment - totalLoan - totalReturned;

//   const goToNextTab = () => {
//     setActiveTab(activeTab + 1);
//   };

//   const goToPrevTab = () => {
//     if (activeTab > 0) setActiveTab(activeTab - 1);
//   };

//   return (
//     <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//       <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//         <Box sx={{ p: 2 }}>
//           <Typography variant="h6" gutterBottom>
//             {t("totals.summary")}
//           </Typography>
//           <Stack spacing={2}>
//             <TextField
//               label={t("totals.labels.totalInvested")}
//               value={totalInvestment.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//             />
//             <TextField
//               label={t("totals.labels.totalLoan")}
//               value={totalLoan.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//             />
//             <TextField
//               label={t("totals.labels.totalReturned")}
//               value={totalReturned.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//             />
//             <TextField
//               label={t("totals.labels.totalClaim")}
//               value={totalClaim.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//             />
//           </Stack>
//           <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
//             <Button variant="outlined" onClick={goToPrevTab}>
//               {t("totals.buttons.back")}
//             </Button>
//             <Button variant="contained" color="primary" onClick={goToNextTab}>
//               {t("totals.buttons.next")}
//             </Button>
//           </Box>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default TotalsSection;


// import React, { useState, useEffect } from "react";
// import { Box, Typography, TextField, Button, Container, Paper, Stack } from "@mui/material";
// import { useTranslation } from "react-i18next";

// const TotalsSection = ({ investments, loans, returneds, total, activeTab, setActiveTab }) => {
//   const { t } = useTranslation();

//   const totalInvestment = Number(investments) || 0;
//   const totalLoan = Number(loans) || 0;
//   const totalReturned = Number(returneds) || 0;

//   // Always compute totalClaim strictly with formula, no conditionals altering it
//   const totalClaim = totalInvestment - totalLoan - totalReturned;

//   // Local state for error display
//   const [claimError, setClaimError] = useState("");

//   // Set error if totalClaim is negative
//   useEffect(() => {
//     if (totalClaim < 0) {
//       setClaimError("You're not eligible for claims");
//     } else {
//       setClaimError("");
//     }
//   }, [totalClaim]);

//   const goToNextTab = () => {
//     setActiveTab(activeTab + 1);
//   };

//   const goToPrevTab = () => {
//     if (activeTab > 0) setActiveTab(activeTab - 1);
//   };

//   return (
//     <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//       <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//         <Box sx={{ p: 2 }}>
//           <Typography variant="h6" gutterBottom>
//             {t("totals.summary")}
//           </Typography>
//           <Stack spacing={2}>
//             <TextField
//               label={t("totals.labels.totalInvested")}
//               value={totalInvestment.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//             />
//             <TextField
//               label={t("totals.labels.totalLoan")}
//               value={totalLoan.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//             />
//             <TextField
//               label={t("totals.labels.totalReturned")}
//               value={totalReturned.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//             />
//             <TextField
//               label={t("totals.labels.totalClaim")}
//               value={totalClaim.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//               error={!!claimError}
//               helperText={claimError || ""}
//             />
//           </Stack>
//           <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
//             <Button variant="outlined" onClick={goToPrevTab}>
//               {t("totals.buttons.back")}
//             </Button>
//             <Button variant="contained" color="primary" onClick={goToNextTab}>
//               {t("totals.buttons.next")}
//             </Button>
//           </Box>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default TotalsSection;


// import React, { useState, useEffect } from "react";
// import { Box, Typography, TextField, Button, Container, Paper, Stack } from "@mui/material";
// import { useTranslation } from "react-i18next";

// const TotalsSection = ({ investments, loans, returneds, total, activeTab, setActiveTab }) => {
//   const { t } = useTranslation();

//   const totalInvestment = Number(investments) || 0;
//   const totalLoan = Number(loans) || 0;
//   const totalReturned = Number(returneds) || 0;

//   // Always compute totalClaim strictly with formula, no conditionals altering it
//   const totalClaim = totalInvestment - totalLoan - totalReturned;

//   // Local state for error display
//   const [claimError, setClaimError] = useState("");

//   // Set error if totalClaim is negative OR zero
//   useEffect(() => {
//     if (totalClaim <= 0) {
//       setClaimError("You're not eligible for claims");
//     } else {
//       setClaimError("");
//     }
//   }, [totalClaim]);

//   const goToNextTab = () => {
//     // Check for formik errors or negative/zero claim before proceeding
//     if (claimError) {
//       // Show error (already visible in TextField helperText) and prevent navigation
//       return;
//     }
//     setActiveTab(activeTab + 1);
//   };

//   const goToPrevTab = () => {
//     if (activeTab > 0) setActiveTab(activeTab - 1);
//   };

//   return (
//     <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//       <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//         <Box sx={{ p: 2 }}>
//           <Typography variant="h6" gutterBottom>
//             {t("totals.summary")}
//           </Typography>
//           <Stack spacing={2}>
//             <TextField
//               label={t("totals.labels.totalInvested")}
//               value={totalInvestment.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//             />
//             <TextField
//               label={t("totals.labels.totalLoan")}
//               value={totalLoan.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//             />
//             <TextField
//               label={t("totals.labels.totalReturned")}
//               value={totalReturned.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//             />
//             <TextField
//               label={t("totals.labels.totalClaim")}
//               value={totalClaim.toFixed(2)}
//               InputProps={{ readOnly: true }}
//               fullWidth
//               margin="normal"
//               error={!!claimError}
//               helperText={claimError || ""}
//             />
//           </Stack>
//           <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
//             <Button variant="outlined" onClick={goToPrevTab}>
//               {t("totals.buttons.back")}
//             </Button>
//             <Button 
//               variant="contained" 
//               color="primary" 
//               onClick={goToNextTab}
//               disabled={!!claimError} // Also disable button when error exists
//             >
//               {t("totals.buttons.next")}
//             </Button>
//           </Box>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default TotalsSection;
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Container,
  Paper,
  Stack,
} from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CreditCardOffIcon from "@mui/icons-material/CreditCardOff";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useTranslation } from "react-i18next";

const StatCard = ({ icon, label, value, color, bgGradient, iconBg }) => (
  <Box
    sx={{
      borderRadius: "18px",
      p: 3,
      background: bgGradient,
      border: `1.5px solid ${color}22`,
      display: "flex",
      alignItems: "center",
      gap: 2,
      transition: "transform 0.2s, box-shadow 0.2s",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: `0 8px 28px ${color}20`,
      },
    }}
  >
    <Box
      sx={{
        width: 48,
        height: 48,
        borderRadius: "14px",
        background: iconBg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        boxShadow: `0 4px 14px ${color}30`,
      }}
    >
      {React.cloneElement(icon, { sx: { color: "#fff", fontSize: 22 } })}
    </Box>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography
        sx={{
          fontSize: "0.72rem",
          fontWeight: 700,
          color: "#64748b",
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          fontFamily: "'DM Sans', sans-serif",
          mb: 0.25,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: "1.35rem",
          fontWeight: 800,
          color: "#1e293b",
          fontFamily: "'DM Sans', sans-serif",
          letterSpacing: "-0.02em",
        }}
      >
        ₹{Number(value || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
      </Typography>
    </Box>
  </Box>
);

const TotalsSection = ({ investments, loans, returneds, total, activeTab, setActiveTab }) => {
  const { t } = useTranslation();

  const totalInvestment = Number(investments) || 0;
  const totalLoan = Number(loans) || 0;
  const totalReturned = Number(returneds) || 0;
  const totalClaim = totalInvestment - totalLoan - totalReturned;
  const [claimError, setClaimError] = useState("");

  useEffect(() => {
    setClaimError(totalClaim <= 0 ? "You're not eligible for claims" : "");
  }, [totalClaim]);

  const goToNextTab = () => { if (!claimError) setActiveTab(activeTab + 1); };
  const goToPrevTab = () => { if (activeTab > 0) setActiveTab(activeTab - 1); };

  const eligible = totalClaim > 0;

  return (
    <Container maxWidth={false} sx={{ mt: 3, maxWidth: 800 }}>
      <Paper
        elevation={0}
        sx={{
          p: 4,
          borderRadius: "24px",
          border: "1.5px solid #e2e8f0",
          background: "#fff",
          boxShadow: "0 8px 40px rgba(59,130,246,0.08)",
        }}
      >
        {/* Header */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 800,
              fontFamily: "'DM Sans', sans-serif",
              background: "linear-gradient(135deg, #1e293b 0%, #3b82f6 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              mb: 0.5,
            }}
          >
            {t("totals.summary") || "Claim Summary"}
          </Typography>
          <Typography sx={{ color: "#94a3b8", fontSize: "0.85rem", fontFamily: "'DM Sans', sans-serif" }}>
            Your financial summary for this claim
          </Typography>
        </Box>

        <Stack spacing={2}>
          {/* Stat Cards */}
          <StatCard
            icon={<TrendingUpIcon />}
            label={t("totals.labels.totalInvested") || "Total Invested"}
            value={totalInvestment}
            color="#3b82f6"
            bgGradient="linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)"
            iconBg="linear-gradient(135deg, #3b82f6, #2563eb)"
          />
          <StatCard
            icon={<CreditCardOffIcon />}
            label={t("totals.labels.totalLoan") || "Total Loan Outstanding"}
            value={totalLoan}
            color="#f59e0b"
            bgGradient="linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)"
            iconBg="linear-gradient(135deg, #f59e0b, #d97706)"
          />
          <StatCard
            icon={<TrendingDownIcon />}
            label={t("totals.labels.totalReturned") || "Total Returned"}
            value={totalReturned}
            color="#8b5cf6"
            bgGradient="linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)"
            iconBg="linear-gradient(135deg, #8b5cf6, #7c3aed)"
          />

          {/* Divider */}
          <Box
            sx={{
              height: "1px",
              background: "linear-gradient(90deg, transparent, #e2e8f0, transparent)",
              my: 1,
            }}
          />

          {/* Net Claim Card */}
          <Box
            sx={{
              borderRadius: "20px",
              p: 3.5,
              background: eligible
                ? "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)"
                : "linear-gradient(135deg, #fff5f5 0%, #fee2e2 100%)",
              border: eligible ? "2px solid #10b981" : "2px solid #ef4444",
              position: "relative",
              overflow: "hidden",
              transition: "all 0.3s",
            }}
          >
            {/* Background decoration */}
            <Box
              sx={{
                position: "absolute",
                top: -20,
                right: -20,
                width: 100,
                height: 100,
                borderRadius: "50%",
                background: eligible ? "rgba(16,185,129,0.08)" : "rgba(239,68,68,0.08)",
              }}
            />
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, position: "relative" }}>
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: "16px",
                  background: eligible
                    ? "linear-gradient(135deg, #10b981, #059669)"
                    : "linear-gradient(135deg, #ef4444, #dc2626)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: eligible ? "0 6px 20px rgba(16,185,129,0.4)" : "0 6px 20px rgba(239,68,68,0.4)",
                  flexShrink: 0,
                }}
              >
                {eligible ? (
                  <EmojiEventsIcon sx={{ color: "#fff", fontSize: 26 }} />
                ) : (
                  <WarningAmberIcon sx={{ color: "#fff", fontSize: 26 }} />
                )}
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: 700,
                    color: eligible ? "#065f46" : "#991b1b",
                    textTransform: "uppercase",
                    letterSpacing: "0.06em",
                    fontFamily: "'DM Sans', sans-serif",
                    mb: 0.25,
                  }}
                >
                  {t("totals.labels.totalClaim") || "Net Claim Amount"}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "2rem",
                    fontWeight: 900,
                    color: eligible ? "#059669" : "#dc2626",
                    fontFamily: "'DM Sans', sans-serif",
                    letterSpacing: "-0.03em",
                    lineHeight: 1,
                  }}
                >
                  ₹{totalClaim.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                </Typography>
                {!eligible && (
                  <Typography sx={{ fontSize: "0.8rem", color: "#991b1b", fontWeight: 600, mt: 0.5, fontFamily: "'DM Sans', sans-serif" }}>
                    ⚠️ {claimError}
                  </Typography>
                )}
              </Box>
              {eligible && (
                <Box
                  sx={{
                    background: "linear-gradient(135deg, #10b981, #059669)",
                    color: "#fff",
                    borderRadius: "10px",
                    px: 2,
                    py: 0.75,
                    fontSize: "0.75rem",
                    fontWeight: 800,
                    fontFamily: "'DM Sans', sans-serif",
                    letterSpacing: "0.04em",
                    textTransform: "uppercase",
                    boxShadow: "0 4px 12px rgba(16,185,129,0.35)",
                  }}
                >
                  Eligible ✓
                </Box>
              )}
            </Box>

            {/* Formula breakdown */}
            {eligible && (
              <Box
                sx={{
                  mt: 2,
                  pt: 2,
                  borderTop: "1px solid rgba(16,185,129,0.2)",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  flexWrap: "wrap",
                }}
              >
                <Typography sx={{ fontSize: "0.78rem", color: "#065f46", fontFamily: "monospace", fontWeight: 600 }}>
                  ₹{totalInvestment.toLocaleString("en-IN")}
                </Typography>
                <Typography sx={{ fontSize: "0.78rem", color: "#6b7280", fontFamily: "monospace" }}>−</Typography>
                <Typography sx={{ fontSize: "0.78rem", color: "#b45309", fontFamily: "monospace", fontWeight: 600 }}>
                  ₹{totalLoan.toLocaleString("en-IN")}
                </Typography>
                <Typography sx={{ fontSize: "0.78rem", color: "#6b7280", fontFamily: "monospace" }}>−</Typography>
                <Typography sx={{ fontSize: "0.78rem", color: "#6d28d9", fontFamily: "monospace", fontWeight: 600 }}>
                  ₹{totalReturned.toLocaleString("en-IN")}
                </Typography>
                <Typography sx={{ fontSize: "0.78rem", color: "#6b7280", fontFamily: "monospace" }}>=</Typography>
                <Typography sx={{ fontSize: "0.78rem", color: "#059669", fontFamily: "monospace", fontWeight: 800 }}>
                  ₹{totalClaim.toLocaleString("en-IN")}
                </Typography>
              </Box>
            )}
          </Box>
        </Stack>

        {/* Navigation */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}>
          <Button
            variant="outlined"
            onClick={goToPrevTab}
            sx={{
              borderRadius: "12px",
              borderColor: "#e2e8f0",
              color: "#64748b",
              fontWeight: 600,
              fontFamily: "'DM Sans', sans-serif",
              px: 3,
              "&:hover": { borderColor: "#3b82f6", color: "#3b82f6", background: "#eff6ff" },
            }}
          >
            {t("totals.buttons.back") || "Back"}
          </Button>
          <Button
            variant="contained"
            onClick={goToNextTab}
            disabled={!!claimError}
            sx={{
              borderRadius: "12px",
              background: eligible
                ? "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)"
                : "#e2e8f0",
              fontWeight: 700,
              fontFamily: "'DM Sans', sans-serif",
              px: 4,
              boxShadow: eligible ? "0 4px 20px rgba(59,130,246,0.35)" : "none",
              "&:hover": eligible
                ? { background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)", transform: "translateY(-1px)" }
                : {},
              "&.Mui-disabled": { background: "#f1f5f9", color: "#94a3b8" },
              transition: "all 0.25s ease",
            }}
          >
            {t("totals.buttons.next") || "Next"} →
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default TotalsSection;